(function () {

  function initChoosePackTooltip(root) {

    root = root || document;

    const wrapper = root.querySelector(
      '[data-choose-pack-tooltip]'
    );

    if (!wrapper) return;


    /*
     * Find the product-info container.
     */
    const productInfo =
      wrapper.closest('product-info') || root;


    /*
     * Tooltip elements.
     */
    const tooltips = {
      single: wrapper.querySelector(
        '[data-tooltip-content="single"]'
      ),

      two: wrapper.querySelector(
        '[data-tooltip-content="two"]'
      ),

      five: wrapper.querySelector(
        '[data-tooltip-content="five"]'
      )
    };


    /*
     * Get all pack labels.
     */
    function getPackLabels() {

      return Array.from(
        productInfo.querySelectorAll(
          'fieldset label, .product-form__input label, .custom_variant label'
        )
      ).filter(function (label) {

        const text =
          label.textContent
            .trim()
            .toLowerCase();

        return (
          text.includes('single piece') ||
          text.includes('set of 2') ||
          text.includes('set of 5')
        );

      });

    }


    /*
     * Convert label text into tooltip key.
     */
    function getPackType(text) {

      text = text.toLowerCase();

      if (text.includes('single piece')) {
        return 'single';
      }

      if (text.includes('set of 2')) {
        return 'two';
      }

      if (text.includes('set of 5')) {
        return 'five';
      }

      return null;
    }


    /*
     * Hide ALL tooltips.
     */
    function hideAll() {

      Object.keys(tooltips).forEach(function (key) {

        if (!tooltips[key]) return;

        tooltips[key].classList.remove(
          'is-visible'
        );

      });

    }


    /*
     * Show ONE tooltip only.
     */
    function showTooltip(type, targetLabel) {

      hideAll();

      if (
        !type ||
        !tooltips[type]
      ) {
        return;
      }

      const tooltip = tooltips[type];

      tooltip.classList.add('is-visible');


      /*
       * Desktop keeps the CSS-based positioning.
       */
      if (window.innerWidth > 749) {
        return;
      }


      /*
       * MOBILE:
       *
       * Position tooltip directly below
       * the actual pack button.
       */
      if (!targetLabel) {
        return;
      }


      const labelRect =
        targetLabel.getBoundingClientRect();

      const wrapperRect =
        wrapper.getBoundingClientRect();


      /*
       * Find the center of the actual
       * selected/hovered button.
       */
      const labelCenter =
        labelRect.left +
        (labelRect.width / 2);


      /*
       * Tooltip width.
       */
      const tooltipWidth =
        Math.min(
          162,
          window.innerWidth - 32
        );


      /*
       * Desired left position.
       */
      let left =
        labelCenter -
        (tooltipWidth / 2);


      /*
       * Keep tooltip inside screen.
       */
      const minimumLeft = 16;

      const maximumLeft =
        window.innerWidth -
        tooltipWidth -
        16;


      left =
        Math.max(
          minimumLeft,
          Math.min(
            left,
            maximumLeft
          )
        );


      /*
       * Position relative to our
       * tooltip wrapper.
       */
      const relativeLeft =
        left -
        wrapperRect.left;


      /*
       * Position directly below
       * the actual button.
       */
      const relativeTop =
        labelRect.bottom -
        wrapperRect.top +
        10;


      tooltip.style.width =
        tooltipWidth + 'px';

      tooltip.style.left =
        relativeLeft + 'px';

      tooltip.style.top =
        relativeTop + 'px';

      tooltip.style.transform =
        'translate(0, 0)';


      /*
       * Move the arrow to the center
       * of the actual pack button.
       */
      const arrowPosition =
        Math.max(
          18,
          Math.min(
            tooltipWidth - 18,
            labelCenter - left
          )
        );

      tooltip.style.setProperty(
        '--tooltip-arrow-left',
        arrowPosition + 'px'
      );
    }


    /*
     * Find currently selected pack.
     */
    function getSelectedPack() {

      const labels = getPackLabels();

      for (const label of labels) {

        const inputId =
          label.getAttribute('for');

        if (!inputId) continue;

        const input =
          productInfo.querySelector('#' + CSS.escape(inputId)) ||
          document.getElementById(inputId);

        if (
          input &&
          input.checked
        ) {

          return getPackType(
            label.textContent
          );

        }

      }

      return null;
    }

    function getSelectedLabel(type) {

      const labels = getPackLabels();

      for (const label of labels) {

        if (
          getPackType(label.textContent) === type
        ) {
          const inputId =
            label.getAttribute('for');

          if (!inputId) continue;

          const input =
            productInfo.querySelector('#' + CSS.escape(inputId)) ||
            document.getElementById(inputId);

          if (
            input &&
            input.checked
          ) {
            return label;
          }
        }
      }

      return null;
    }


    /*
     * Attach hover/click behavior.
     */
    function bindLabels() {

      const labels = getPackLabels();

      labels.forEach(function (label) {

        /*
         * Prevent duplicate event listeners.
         */
        if (
          label.dataset.packTooltipBound === 'true'
        ) {
          return;
        }

        label.dataset.packTooltipBound = 'true';


        const type =
          getPackType(
            label.textContent
          );

        if (!type) return;


        /*
         * HOVER
         */
        label.addEventListener(
          'mouseenter',
          function () {

            showTooltip(type, label);

          }
        );


        /*
         * MOUSE LEAVES
         *
         * Return to selected pack.
         */
        label.addEventListener(
          'mouseleave',
          function () {

            const selected =
              getSelectedPack();

            if (selected) {

              showTooltip(
                selected,
                getSelectedLabel(selected)
              );

            } else {

              hideAll();

            }

          }
        );


        /*
         * CLICK / SELECT
         */
        label.addEventListener(
          'click',
          function () {

            /*
             * Give Shopify time to update
             * the radio input.
             */
            setTimeout(function () {

              const selected =
                getSelectedPack();

              if (selected) {

                showTooltip(
                  selected,
                  label
                );

              } else {

                showTooltip(
                  type,
                  label
                );

              }

            }, 50);

          }
        );


        /*
         * KEYBOARD FOCUS
         */
        label.addEventListener(
          'focusin',
          function () {

            showTooltip(type);

          }
        );


        label.addEventListener(
          'focusout',
          function () {

            const selected =
              getSelectedPack();

            if (selected) {

              showTooltip(selected);

            } else {

              hideAll();

            }

          }
        );

      });

    }


    /*
     * Shopify variant change — scoped to this root only.
     */
    if (!root.dataset || root.dataset.packTooltipChangeBound !== 'true') {
      productInfo.addEventListener(
        'change',
        function (event) {

          if (
            event.target.matches(
              'input[type="radio"], select'
            )
          ) {

            setTimeout(function () {

              bindLabels();

              const selected =
                getSelectedPack();

              if (selected) {

                showTooltip(selected);

              }

            }, 50);

          }

        }
      );
    }


    /*
     * Initial setup.
     */
    bindLabels();

    const selected =
      getSelectedPack();

    if (selected) {

      showTooltip(selected);

    } else {

      hideAll();

    }

  }


  document.addEventListener(
    'DOMContentLoaded',
    function () {
      initChoosePackTooltip(document);
    }
  );

  document.addEventListener('product-info:loaded', function (event) {
    const modalRoot = event.target.closest('quick-add-modal');
    if (!modalRoot) return;

    setTimeout(function () {
      initChoosePackTooltip(modalRoot);
    }, 80);
  });


  window.initChoosePackTooltip =
    initChoosePackTooltip;

})();